import React from "react";

import ExtensionIcon from "@mui/icons-material/ExtensionOutlined";

import ListDetailView from "../components/ListDetailView";

export const FeaturesIcon = ExtensionIcon;

const FeaturesPage = () => {
    return <ListDetailView title="Rozšíření" />;
};

export default FeaturesPage;
